import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class ImportLogsService extends RestfulService<Models.ImportLog> {

  constructor(private restService: RestService) {
    super(Models.ImportLog);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('import-logs');
  }

}
